import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'react-native-paper';

import { ArrowOutwardIcon, BlockIcon, FeedbackIcon, ForumIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type PostViewerActionsProps = {
  onItemPress: () => void;
  isCreatorBlocked: boolean;
  handleSharePost: () => void;
  handleChat: () => void;
  handleBlock: () => void;
  handleFlag: () => void;
};

export const PostViewerActions: FC<PostViewerActionsProps> = ({
  onItemPress,
  isCreatorBlocked,
  handleSharePost,
  handleChat,
  handleBlock,
  handleFlag
}) => {
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'screens.post-detail.menu'
  });

  return (
    <>
      {!isCreatorBlocked && (
        <Menu.Item
          leadingIcon={({ color, size }) => (
            <ForumIcon fill={color} width={size} height={size} />
          )}
          title={t('startChat')}
          onPress={() => {
            handleChat();
            onItemPress();
          }}
        />
      )}
      <Menu.Item
        leadingIcon={({ color, size }) => (
          <FeedbackIcon fill={color} width={size} height={size} />
        )}
        title={t('report')}
        onPress={() => {
          handleFlag();
          onItemPress();
        }}
      />
      <Menu.Item
        leadingIcon={({ color, size }) => (
          <BlockIcon fill={color} width={size} height={size} />
        )}
        title={t(isCreatorBlocked ? 'unblock' : 'block')}
        onPress={() => {
          handleBlock();
          onItemPress();
        }}
      />
      <Menu.Item
        leadingIcon={({ color, size }) => (
          <ArrowOutwardIcon fill={color} width={size} height={size} />
        )}
        title={t('share')}
        onPress={() => {
          handleSharePost();
          onItemPress();
        }}
      />
    </>
  );
};
